export default __webpack_public_path__ + "static/7-44fe643a88366478eec68c1ff06f40f0.jpg";